import * as React from 'react';

function PlusCircleBold(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={16} height={17} fill="none" viewBox="0 0 16 17" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M0 8.5c0-4.406 3.563-8 8-8 4.406 0 8 3.594 8 8 0 4.438-3.594 8-8 8-4.438 0-8-3.563-8-8zM8 12a.74.74 0 00.75-.75v-2h2a.74.74 0 00.75-.75.76.76 0 00-.75-.75h-2v-2A.76.76 0 008 5a.74.74 0 00-.75.75v2h-2a.74.74 0 00-.75.75c0 .438.313.75.75.75h2v2c0 .438.313.75.75.75z"
        fill="#2C2C2C"
      />
    </svg>
  );
}

export default PlusCircleBold;
